const manufacturingOrdersTypes = {
  MANUFACTURING_ORDERS_TABLE_STATE_SET: 'MANUFACTURING_ORDERS/TABLE_STATE_SET',
  MANUFACTURING_ORDERS_TABLE_STATE_RESET: 'MANUFACTURING_ORDERS/TABLE_STATE_RESET',
};
export default manufacturingOrdersTypes;
